module.exports = __webpack_public_path__ + "static/media/6D.a8aabd2d.svg";